import React,{useState,useEffect} from "react";
import { makeStyles } from 'tss-react/mui';
import { Button } from "@mui/material";
import SendIcon from "@mui/icons-material/ForwardToInboxOutlined";
import { setError } from "../store/features/error/errorSlice";
import { connect } from "react-redux";
import EmailAutocomplete from "./emailAutocomplete";
import AdminDialog from "./adminDialog";
import { forwardViaEmail } from "../utils/utils";
import AttachmentRow from "./attachmentRow";

const mapDispatchToProps = {
  setError,
};

// The address the server sends these messages from.
const FROM_ADDRESS = "no-reply@my-cloudline.com";

const useStyles = makeStyles()((theme) => ({
  note: {
    marginRight: "auto",
    fontSize: 12,
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  textButton: {
    textTransform: "none",
    color: theme.palette.text.secondary,
  },
  primary: {
    textTransform: "none",
    minWidth: 112,
    color: "#fff",
    backgroundColor: theme.palette.primary.light,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      filter: "brightness(0.93)",
      boxShadow: "none",
    },
  },
}));

const defaultEmailTemplate = (name, type) => `Hello,\n\n${name} has forwarded you a ${type}. Attached you will find a copy of your ${type}.\n\nIf you have any questions or problems, please send a message to support@my-cloudline.com\n\nSincerely,\nMyCloudline`;

const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const ForwardViaEmail = (props) => {
    const { classes } = useStyles();
    const { open, setOpen, setError, type, file, user, defaultValues } = props;
    const [hasEmailError, setEmailHasError] = useState(false);
    const [ recipient, setRecipient ] = useState([]);
    const [sending, setSending] = useState(false);

    const isFax = String(type).toLowerCase() === "fax";
    const kind = isFax ? "fax" : "voicemail";

    // Every time it opens, it starts without recipients.
    useEffect(() => {
      if (open) {
        setRecipient([]);
        setEmailHasError(false);
        setSending(false);
      }
    }, [open, file]);

    const allValid = recipient.length > 0 && recipient.every((email) => isEmailValid(email));
    const canSend = allValid && !hasEmailError && file !== null && file !== undefined && !sending;

    const handleSubmit = async () => {
      if (!canSend) return;
      setSending(true);

      let values = {
        ...defaultValues,
        id: isFax ? file.fid : file.vid,
        group: isFax ? file.group : null,
        type: type
      };

      // The message itself is a standard text; only the recipients change.
      let sanitizedBody = defaultEmailTemplate(user.firstName, type).replace(/(?:\r\n|\r|\n)/g, '<br>');

      let data = {
        to: recipient.toString(),
        from: FROM_ADDRESS,
        subject: `Forwarded ${type} from ${user.firstName + " " + user.lastName}`,
        body: sanitizedBody,
        title: file.hasOwnProperty("title")?file.title:"Voicemail"
      };

      try {
        let email = await forwardViaEmail(values, data);

        if(email instanceof Error) throw email.message;

        setError({
          visible: true,
          type: "success",
          message: "Email Sent Successfully.",
        });
        setOpen(false);
      } catch (error) {
        setSending(false);
        setError({
          visible: true,
          type: "error",
          message: error,
        });
      }
    };

    if (!open) return null;

    return (
      <AdminDialog
        open={open}
        onClose={() => setOpen(false)}
        icon={<SendIcon />}
        title={`Send ${kind} by email`}
        subtitle={`The ${kind} is attached to a standard message.`}
        maxWidth={520}
        footer={
          <>
            <span className={classes.note}>Sent from {FROM_ADDRESS}</span>
            <Button onClick={() => setOpen(false)} className={classes.textButton}>
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={!canSend}
              className={classes.primary}
              onClick={handleSubmit}
            >
              {sending ? "Sending…" : "Send"}
            </Button>
          </>
        }
      >
        <AttachmentRow file={file} type={type} />
        <div>
          <EmailAutocomplete
            value={recipient}
            setValue={setRecipient}
            placeholder="To"
            hasError={hasEmailError}
            setHasError={setEmailHasError}
          />
        </div>
      </AdminDialog>
    );
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForwardViaEmail);
